import React from "react";

const ArrowUp = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="19" x2="12" y2="5" /><polyline points="5 12 12 5 19 12" />
  </svg>
);
const ArrowDown = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" /><polyline points="19 12 12 19 5 12" />
  </svg>
);
const Dash = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const StatCard = ({ label, value, icon, delta, deltaLabel, hint, accent }) => {
  let deltaCls = "sc-card__delta sc-card__delta--flat";
  let DeltaIcon = Dash;
  if (typeof delta === "number") {
    if (delta > 0) { deltaCls = "sc-card__delta sc-card__delta--up"; DeltaIcon = ArrowUp; }
    else if (delta < 0) { deltaCls = "sc-card__delta sc-card__delta--down"; DeltaIcon = ArrowDown; }
  }

  return (
    <div className="sc-card">
      <div className="sc-card__row">
        <div style={{ minWidth: 0 }}>
          <p className="sc-card__label">{label}</p>
          <div className="sc-card__value">{value}</div>
          {(delta !== undefined && delta !== null) || hint ? (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {delta !== undefined && delta !== null && (
                <span className={deltaCls}>
                  <DeltaIcon />
                  {typeof delta === "number" ? `${delta > 0 ? "+" : ""}${delta}${deltaLabel || "%"}` : delta}
                </span>
              )}
              {hint && <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{hint}</span>}
            </div>
          ) : null}
        </div>
        {icon && (
          <div
            className="sc-card__icon"
            style={accent ? { background: accent.bg, color: accent.fg } : undefined}
          >
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
